import React from "react";
import { cn } from "@/lib/utils";

/**
 * ALGOS Flywheel motif — Identify → Deploy → Govern → Measure.
 * Used as decorative background, loader, and empty-state illustration.
 * Rotates with `prefers-reduced-motion` respected.
 */
export function Flywheel({
  size = 320,
  className,
  opacity = 0.06,
  spin = true,
  stroke = "#137DC5",
}) {
  return (
    <svg
      viewBox="0 0 320 320"
      width={size}
      height={size}
      fill="none"
      className={cn(spin && "rotate-flywheel", className)}
      style={{ opacity }}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="flywheel-motif"
    >
      {/* Concentric guide rings */}
      <circle cx="160" cy="160" r="148" stroke={stroke} strokeWidth="0.6" />
      <circle cx="160" cy="160" r="120" stroke={stroke} strokeWidth="0.6" />
      <circle cx="160" cy="160" r="92" stroke={stroke} strokeWidth="0.6" />
      <circle cx="160" cy="160" r="64" stroke={stroke} strokeWidth="0.6" />

      {/* Four quadrant arcs representing the loop */}
      <path
        d="M160 12 A148 148 0 0 1 308 160"
        stroke={stroke}
        strokeWidth="3"
      />
      <path
        d="M308 160 A148 148 0 0 1 160 308"
        stroke={stroke}
        strokeWidth="3"
        opacity="0.7"
      />
      <path
        d="M160 308 A148 148 0 0 1 12 160"
        stroke={stroke}
        strokeWidth="3"
        opacity="0.4"
      />
      <path
        d="M12 160 A148 148 0 0 1 160 12"
        stroke={stroke}
        strokeWidth="3"
        opacity="0.2"
      />

      {/* Crosshair spokes */}
      <line x1="160" y1="12" x2="160" y2="308" stroke={stroke} strokeWidth="0.6" />
      <line x1="12" y1="160" x2="308" y2="160" stroke={stroke} strokeWidth="0.6" />

      {/* Stage dots */}
      <circle cx="160" cy="12" r="6" fill={stroke} />
      <circle cx="308" cy="160" r="6" fill={stroke} opacity="0.7" />
      <circle cx="160" cy="308" r="6" fill={stroke} opacity="0.4" />
      <circle cx="12" cy="160" r="6" fill={stroke} opacity="0.2" />
    </svg>
  );
}

export default Flywheel;
